import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { VgImageModule } from '../vg-image/vg-image.module';
import { ProductCoverComponent } from './product-cover.component';
import { RibbonModule } from '../ribbon/ribbon.module';

@NgModule({
    declarations: [
        ProductCoverComponent
    ],
    exports: [
        ProductCoverComponent
    ],
    imports: [
        LazyLoadImageModule,
        CommonModule,
        VgImageModule,
        RibbonModule
    ]
})
export class ProductCoverModule { }